import { useCallback, useEffect, useState } from 'react';

// Simple resend cooldown: call start() to begin a countdown; `remaining` ticks
// down to 0 once per second. Used to gate the "Resend OTP" buttons on the
// registration forms (backend enforces a 30s OTP cooldown).
export const useResendTimer = (seconds = 30) => {
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    if (remaining <= 0) return undefined;
    const t = setTimeout(() => setRemaining((r) => r - 1), 1000);
    return () => clearTimeout(t);
  }, [remaining]);

  const start = useCallback(() => setRemaining(seconds), [seconds]);
  const reset = useCallback(() => setRemaining(0), []);

  return { remaining, start, reset, active: remaining > 0 };
};
